// http://stackoverflow.com/questions/29725828/update-style-of-a-component-onscroll-in-react-js
import React from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import './Header.css';

class Header extends React.Component {

  render() {
    const {navbar} = this.props.headerData;
    return (
      <header id='top' className='main-header'>
        <Navbar navbarLinks={navbar}/>
        <Hero />
      </header>
    );
  }
}

Header.propTypes = {
  headerData: React.PropTypes.object.isRequired
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js